import React from 'react';
import { Box, Typography } from '@mui/material';
import { DESIGN_TOKENS } from '../../../styles/constants';

interface Tab {
  label: string;
  value: string;
  badge?: number;
}

interface FilterTabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (value: string) => void;
}

const FilterTabs: React.FC<FilterTabsProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '8px',
      }}
    >
      {tabs.map((tab) => (
        <Box
          key={tab.value}
          onClick={() => onTabChange(tab.value)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 20px 7px',
            height: '39px',
            borderRadius: '16px',
            backgroundColor: activeTab === tab.value ? '#AC654D' : '#F6F8F8',
            cursor: 'pointer',
            transition: DESIGN_TOKENS.transitions.fast,
            '&:hover': {
              opacity: 0.8,
            },
          }}
        >
          <Typography
            sx={{
              fontFamily: DESIGN_TOKENS.typography.fontFamily,
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '22.4px',
              color: activeTab === tab.value ? '#FFFFFF' : '#181818',
            }}
          >
            {tab.label}
          </Typography>
          {tab.badge !== undefined && tab.badge > 0 && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '20px',
                height: '20px',
                padding: '0 6px',
                borderRadius: '10px',
                backgroundColor: activeTab === tab.value ? 'rgba(255, 255, 255, 0.3)' : '#426A53',
                color: activeTab === tab.value ? '#FFFFFF' : '#FFFFFF',
                fontSize: '12px',
                fontWeight: 600,
                lineHeight: '20px',
              }}
            >
              {tab.badge}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default FilterTabs;


